import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** Body of an optional builder step (Calculator, Chart, Screener) that this form does not use yet. */
export function BuilderStepOff({
    icon: Icon,
    title,
    description,
    children,
    testId,
}: {
    icon: LucideIcon;
    title: string;
    description: string;
    /** The button that switches the step on. */
    children?: ReactNode;
    testId?: string;
}) {
    return (
        <div className="flex flex-col items-center gap-3 px-6 py-12 text-center" data-testid={testId}>
            <span className="flex justify-center items-center bg-muted rounded-full size-10 text-muted-foreground">
                <Icon size={18} aria-hidden />
            </span>
            <div className="space-y-1 max-w-sm">
                <p className="font-medium text-sm">{title}</p>
                <p className="text-muted-foreground text-xs text-pretty">{description}</p>
            </div>
            {children}
        </div>
    );
}
